import Reflux from 'reflux';

export default Reflux.createActions([
   'toggle'
]);


// WEBPACK FOOTER //
// ./src/app/mobile-menu/actions.js